module.exports = __webpack_public_path__ + "static/media/extraLava.854cf8e7.mp4";